import { CartHelper } from "./CartHelper.js"
import { FormsHelper } from "./FormsHelper.js"
import { Spinner } from "./Spinner.js"
import { Toast } from "./Toast.js"
import { I18N } from "./I18N.js"
import { TermsOfService } from "./TermsOfService.js"
import { LebeledInput } from "./lib/LabeledInput.js"
import { loadScript } from "@paypal/paypal-js"
import { OrderHelper } from "./OrderHelper.js"

export class Checkout {

	_target
	_appContext
	_orderVO
	_amount
	_currency = 'EUR'
	_processInstanceId
	_onProcessStartedHandlers = []
	_onEmptyCartHandlers = []
	_isPayPalInitialized
	_payPalSandboxClientId = 'ARTJJ3-IxdF_gQRig9QkBPr5ETATR6d3EShMkwGlX1eeCo9UAUPj7YEXHSRi-Hd-pMcwdJPzIe_aduzc'
	_payPalProductionClientId = 'AfGjsg_rEGDW8glJBJM4myTgJq60QA7GCZBG78W9WxX4S9kcZlgbwxRDJKVNroaymdJ0jc43oPyjwO-k'
	_payPalClientId = this._payPalSandboxClientId

	constructor(target) {
		this._target = document.getElementById(target)
		this._target.setAttribute('hidden', '')
		this._target.innerHTML = `
			<h2 i18n>Checkout</h2>
			<div>
				<h3 i18n>Payment</h3>
				<fieldset>
					<legend i18n>Payment Method</legend>
					${LebeledInput.create('<label for="paymentMethodCashRb" i18n>Cash</label>', '<input type="radio" id="paymentMethodCashRb" name="payment" value="cash" checked>', true)}
					${LebeledInput.create('<label for="paymentMethodPayPalRb" i18n>PayPal</label>', '<input type="radio" id="paymentMethodPayPalRb" name="payment" value="paypal">', true)}
				</fieldset>
			</div>
			<fieldset id="customerContact">
				<legend i18n>Contact</legend>
				${LebeledInput.create('<label for="firstName" required i18n>First Name</label>', '<input id="firstName" required>', false)}
				${LebeledInput.create('<label for="lastName" required i18n>Last Name</label>', '<input id="lastName" required>', false)}
				${LebeledInput.create('<label for="phone" required i18n>Phone</label>', '<input id="phone" required>', false)}
				${LebeledInput.create('<label for="email" required i18n>E-Mail</label>', '<input id="email" required>', false)}
			</fieldset>
			<div id="invoiceAddress" hidden>
				<fieldset>
					<legend i18n>Invoice Address</legend>
					${LebeledInput.create('<label for="invoiceStreet" i18n>Street</label>', '<input id="invoiceStreet">', false)}
					${LebeledInput.create('<label for="invoiceNr" i18n>Nr.</label>', '<input id="invoiceNr">', false)}
					<div class="field-group">
						${LebeledInput.create('<label for="invoicePostalCode" i18n>Postal Code</label>', '<input id="invoicePostalCode">', false)}
						${LebeledInput.create('<label for="invoiceCity" i18n>City</label>', '<input id="invoiceCity">', false)}
					</div>
					${LebeledInput.create('<label for="invoiceCountry" i18n>Country</label>', '<input id="invoiceCountry">', false)}
				</fieldset>
			</div>
			<div>
				<fieldset>
					<legend i18n>Legal</legend>
					${LebeledInput.create('<label for="termsOfServiceAcceptedCb" required i18n>Terms of service accepted</label><button id="dispalyTermsOfServiceBtn" i18n>Display terms of service</button>', '<input type="checkbox" id="termsOfServiceAcceptedCb" required>', true, null, ['wide'])}
					${LebeledInput.create('<label for="acceptNewsletterCb" i18n>Send me e-mails about offers and promotions</label>', '<input type="checkbox" id="acceptNewsletterCb">', true)}
					${LebeledInput.create('<label for="rememberSessionAfterOrderCb" i18n>Remember address and contact for next order</label>', '<input type="checkbox" id="rememberSessionAfterOrderCb" checked>', true)}
				</fieldset>
			</div>
			<div>
				<h3 i18n>Buy</h3>
				<button id="buyBtn" class="primary" hidden disabled i18n>Commit</button>
				<div id="paypal-button-container"></div>
			</div>
			<div id="termsOfServiceDialog"></div>
		`
		document.getElementById('termsOfServiceAcceptedCb').checked = sessionStorage.getItem('termsOfServiceAccepted') === 'true'
		document.getElementById('acceptNewsletterCb').checked = localStorage.getItem('newsletterOrdered') !== 'false'

		document.getElementById('buyBtn').addEventListener('click', () => {
			this._orderVO.payment.payWith = 'cash'
			this._orderVO.payment.prepaid = false
			this.checkout()
		})
		document.getElementById('paymentMethodCashRb').addEventListener('change', ev => {
			if (ev.target.checked) {
				document.getElementById('paypal-button-container').setAttribute('hidden', '')
				document.getElementById('buyBtn').removeAttribute('hidden')
				document.getElementById('buyBtn').removeAttribute('disabled')
				//document.getElementById('invoiceAddress').setAttribute('hidden', '')
			}
		})
		document.getElementById('paymentMethodPayPalRb').addEventListener('change', ev => {
			if (ev.target.checked && this._orderVO) {
				// Init PayPal
				this._enablePayPalButtons()
				document.getElementById('buyBtn').setAttribute('hidden', '')
				document.getElementById('buyBtn').setAttribute('disabled', '')
				document.getElementById('paypal-button-container').removeAttribute('hidden')
			}
		})
		FormsHelper.setAndRememberInputValue('firstName', null)
		document.getElementById('firstName').addEventListener('change', ev => {
			FormsHelper.setAndRememberInputValue('firstName', ev.target.value)
		})
		FormsHelper.setAndRememberInputValue('lastName', null)
		document.getElementById('lastName').addEventListener('change', ev => {
			FormsHelper.setAndRememberInputValue('lastName', ev.target.value)
		})
		FormsHelper.setAndRememberInputValue('phone', null)
		document.getElementById('phone').addEventListener('change', ev => {
			FormsHelper.setAndRememberInputValue('phone', ev.target.value)
		})
		FormsHelper.setAndRememberInputValue('email', null)
		document.getElementById('email').addEventListener('change', ev => {
			FormsHelper.setAndRememberInputValue('email', ev.target.value)
		})
		document.getElementById('termsOfServiceAcceptedCb').addEventListener('change', ev => {
			if (ev.target.checked) {
				if (this._termsOfServiceNotAcceptedToast) {
					this._termsOfServiceNotAcceptedToast.dismiss()
				}
				this._target.querySelector('#termsOfServiceAcceptedCb').removeAttribute('invalid')
				sessionStorage.setItem('termsOfServiceAccepted', 'true')
			}
			else {
				sessionStorage.removeItem('termsOfServiceAccepted')
			}
		})
		document.getElementById('dispalyTermsOfServiceBtn').addEventListener('click', ev => {
			new TermsOfService('termsOfServiceDialog')
		})

		I18N.translateElement(this._target)
		this._target.querySelectorAll('#customerContact input[required]').forEach(requiredInput => {
			requiredInput.addEventListener('keyup', ev => {
				if (ev.target.value) {
					ev.target.removeAttribute('invalid')
				}
			})
		})
	}

	addOnProcessStartedHandlers = (...onProcessStartedHandlers) => this._onProcessStartedHandlers.push(...onProcessStartedHandlers)

	addOnCheckoutDoneHandlers = (...onEmptyCartHandlers) => this._onEmptyCartHandlers.push(...onEmptyCartHandlers)

	setOrderVO = orderVO => {
		this._orderVO = orderVO
		if (this._orderVO) {
			this._amount = OrderHelper.roundCurrency(this._orderVO.net + this._orderVO.tax)
			if (this._orderVO.invoiceAddress) {
				this.updateInvoiceAddressForm(this._orderVO.invoiceAddress)
			}
			if (this._orderVO.contact) {
				this.updateContactForm(this._orderVO.contact)
			}
			// Init Payment
			this._orderVO.payment = {
				prepaid: false,
				paid: false,
				paidAt: null
			}

			document.getElementById('buyBtn').removeAttribute('disabled')
			if (document.getElementById('paymentMethodCashRb').checked) {
				document.getElementById('buyBtn').removeAttribute('hidden')
			}
		}
		else {
			this._amount = null
			document.getElementById('buyBtn').setAttribute('disabled', '')
		}
	}

	setPrepaidRequired = prepaidRequired => {
		if (prepaidRequired) {
			if (document.getElementById('paymentMethodCashRb').checked) {
				// Switch to Credit Card over Braintree
				document.getElementById('paymentMethodPayPalRb').setAttribute('checked', '')
				document.getElementById('paymentMethodCashRb').removeAttribute('checked')
				document.getElementById('paymentMethodCashRb').setAttribute('disabled', '')
			}
		}
		else {
			document.getElementById('paymentMethodCashRb').removeAttribute('disabled')
		}
	}

	updateInvoiceAddressForm = invoiceAddress => {
		document.getElementById('invoiceStreet').value = invoiceAddress.street
		document.getElementById('invoiceNr').value = invoiceAddress.nr
		document.getElementById('invoicePostalCode').value = invoiceAddress.postalCode
		document.getElementById('invoiceCity').value = invoiceAddress.city
		document.getElementById('invoiceCountry').value = invoiceAddress.country
	}

	updateContactForm = contact => {
		FormsHelper.setAndRememberInputValue('firstName', contact.firstName)
		FormsHelper.setAndRememberInputValue('lastName', contact.lastName)
		FormsHelper.setAndRememberInputValue('email', contact.email)
		FormsHelper.setAndRememberInputValue('phone', contact.phone)
	}

	readContactForm = () => {
		this._orderVO.contact.firstName = document.getElementById('firstName').value
		this._orderVO.contact.lastName = document.getElementById('lastName').value
		this._orderVO.contact.email = document.getElementById('email').value
		this._orderVO.contact.phone = document.getElementById('phone').value
	}

	checkout = async () => {
		if (!this._orderVO) {
			return
		}
		this._checkTermsOfServiceAccepted()
		// Check contact data
		if (!this._checkRequiredInputs()) {
			return
		}
		this.readContactForm()
		this._acceptToReceiveNewsletter(this._target.querySelector('#acceptNewsletterCb').checked)

		// Update payment
		this._orderVO.payment.amount = this._amount
		this._orderVO.payment.currency = this._currency


		const requestBody = this._createCamundaRequestBody()
		this._setCamundaStringRequestVariable(requestBody, 'orderId', this._orderVO.orderId) // Predefined
		this._setCamundaStringRequestVariable(requestBody, 'wantedLocalDateTime', this._orderVO.wantedLocalDateTime)
		this._setCamundaStringRequestVariable(requestBody, 'storeId', this._orderVO.storeId)
		this._setCamundaStringRequestVariable(requestBody, 'delivery', this._orderVO.delivery)
		this._setCamundaStringRequestVariable(requestBody, 'remarks', this._orderVO.remarks)
		this._setCamundaJsonRequestVariable(requestBody, 'cart', this._orderVO.cart)
		this._setCamundaDoubleRequestVariable(requestBody, 'net', this._orderVO.net)
		this._setCamundaDoubleRequestVariable(requestBody, 'tax', this._orderVO.tax)
		this._setCamundaJsonRequestVariable(requestBody, 'taxRates', this._orderVO.taxRates)
		this._setCamundaJsonRequestVariable(requestBody, 'fees', this._orderVO.fees)
		this._setCamundaJsonRequestVariable(requestBody, 'discounts', this._orderVO.discounts)
		this._setCamundaJsonRequestVariable(requestBody, 'tour', this._orderVO.tour)
		this._setCamundaJsonRequestVariable(requestBody, 'storeAddress', this._orderVO.storeAddress)
		this._setCamundaJsonRequestVariable(requestBody, 'storeContact', this._orderVO.storeContact)
		this._setCamundaJsonRequestVariable(requestBody, 'deliveryAddress', this._orderVO.deliveryAddress)
		this._setCamundaJsonRequestVariable(requestBody, 'invoiceAddress', this._orderVO.invoiceAddress)
		this._setCamundaJsonRequestVariable(requestBody, 'contact', this._orderVO.contact)
		this._setCamundaJsonRequestVariable(requestBody, 'payment', this._orderVO.payment)

		// const p1 = 'AcceptOrder'
		const p2 = 'FoodFulfillment'

		const spinner = new Spinner(this._target, 15)
		fetch(`/engine-rest/process-definition/key/${p2}/start`, {
			method: 'POST',
			mode: 'cors', // no-cors, *cors, same-origin
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'same-origin', // include, *same-origin, omit
			headers: {
				'Content-Type': 'application/json'
			},
			referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
			body: JSON.stringify(requestBody)
		})
			.then(response => {
				if (response.ok) {
					response.json()
						.then(json => {
							// Order placed successfully
							console.log('Response: ', json)
							new Toast('toaster', I18N.translate('Order placed'), Toast.INFO, 15)
							this._processInstanceId = json.id
							console.log('processInstanceId: ', this._processInstanceId)
							this._onProcessStartedHandlers.forEach(handler => handler(this._processInstanceId))
							this._orderVO.orderId = CartHelper.getUuid() // Generate a new orderId after old order has been sent
							this._orderVO = null
							this._onEmptyCartHandlers.forEach(handler => handler())
							// Delete cookies, sessionStorage and localStorage
							if (!this._target.querySelector('#rememberSessionAfterOrderCb').checked) {
								localStorage.clear()
								sessionStorage.clear()
								document.cookie.split(";")
									.forEach(c => {
										document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/")
									})
							}
							spinner.dismiss()
							// Switch to confirmation
							this._appContext.setOpen('confirmation', true)
							this._appContext.setActive('confirmation')
						})
				}
				else {
					spinner.dismiss()
					response.json()
						.then(json => {
							console.log('Failed to start process instance: ', json)
							new Toast('toaster', I18N.translateAndFormat('A technical error occurred. Please try again later, with other input or call us! Problem info:<br>{0}', json.error + '<br>' + json.cause), Toast.ERROR)
						})
						.catch(e => {
							console.log('Failed to start process instance: ', response)
							new Toast('toaster', I18N.translateAndFormat('A technical error occurred. Please try again later, with other input or call us! Problem info:<br>{0}', response.statusText), Toast.ERROR)
						})
				}
			})
			.catch(e => {
				spinner.dismiss()
				console.log(e)
				new Toast('toaster', I18N.translateAndFormat('A technical error occurred. Please try again later, with other input or call us! Problem info:<br>{0}', e), Toast.ERROR)
			})
	}

	_enablePayPalButtons = () => {
		if (this._isPayPalInitialized) {
			return
		}
		const spinner = new Spinner(document.getElementById('checkout'), 15)
		loadScript({
			'client-id': this._payPalClientId,
			'currency': this._currency,
			'intent': 'authorize' // 'capture'
		})
			.then(paypal => {
				console.log('PayPal module loaded', paypal)
				paypal.Buttons({
					onInit: (data, actions) => {
						if (!this._checkTermsOfServiceAccepted()) {
							// Disable the buttons
							actions.disable();
							// Listen for changes to the checkbox
							document.getElementById('termsOfServiceAcceptedCb').addEventListener('change', ev => {
								if (this._checkTermsOfServiceAccepted()) {
									actions.enable()
								}
								else {
									actions.disable()
								}
							})
						}
					},
					// Sets up the transaction when a payment button is clicked
					createOrder: (data, actions) => {
						if (!this._checkRequiredInputs()) {
							return
						}
						const payPalItems = this._orderVO.cart.items.map(i => ({
							name: i.product.productName,
							quantity: i.qty,
							unit_amount: {
								value: OrderHelper.roundCurrency(CartHelper._getItemNet(i) + CartHelper._getItemTax(i)),
								currency_code: this._currency
							}
						}))
						const itemTotalValue = payPalItems.map(pi1 => pi1.unit_amount.value * pi1.quantity).reduce((pi1, pi2) => pi1 + pi2)
						const payPalBReakdown = {
							item_total: {
								value: OrderHelper.roundCurrency(itemTotalValue),
								currency_code: this._currency
							}
						}
						let payPalFees = 0
						if (this._orderVO.fees && this._orderVO.fees.length > 0) {
							payPalFees = this._orderVO.fees.map(f => f.netFee + f.tax).reduce((pf1, pf2) => pf1 + pf2)
						}
						if (payPalFees > 0) {
							payPalBReakdown.shipping = {
								value: OrderHelper.roundCurrency(payPalFees),
								currency_code: this._currency
							}
						}
						let payPalDiscount = 0
						if (this._orderVO.discounts && this._orderVO.discounts.length > 0) {
							payPalDiscount = this._orderVO.discounts.map(d => d.netDiscount + d.tax).reduce((pd1, pd2) => pd1 + pd2)
						}
						if (payPalDiscount > 0) {
							payPalBReakdown.discount = {
								value: OrderHelper.roundCurrency(payPalDiscount),
								currency_code: this._currency
							}
						}
						const payPalOrder = {
							purchase_units: [{
								custom_id: this._orderVO.orderId,
								amount: {
									value: this._amount,
									currency_code: this._currency,
									breakdown: payPalBReakdown
								},
								items: payPalItems
							}]
						}
						console.debug('PayPal order:', payPalOrder)
						return actions.order.create(payPalOrder)
					},
					// Finalize the transaction after payer approval
					onApprove: (data, actions) => {
						return actions.order.authorize()
							.then(orderData => {
								// Successful capture! For dev/demo purposes:
								console.log('Authorize result', orderData)
								//orderData.purchase_units[0].payments.captures[0]
								// alert(`Transaction ${transaction.status}: ${transaction.id}\n\nSee console for all available details`);
								// When ready to go live, remove the alert and show a success message within this page. For example:
								// const element = document.getElementById('paypal-button-container');
								// element.innerHTML = '<h3>Thank you for your payment!</h3>';
								// Or go to another URL:  actions.redirect('thank_you.html');
								const authorization = orderData.purchase_units[0].payments.authorizations[0]
								if (authorization.status === 'CREATED') {
									this._orderVO.payment.payWith = 'paypal'
									this._orderVO.payment.prepaid = true
									this._orderVO.payment.paypalAuthorizationId = authorization.id
									this.checkout()
								}
								else {
									new Toast('toaster', I18N.translateAndFormat('PayPal hasn´t authorized the payment!'), Toast.ERROR)
								}
							})
					},
					onError: err => {
						console.error('PaypalCheckout error:', err)
						let errMsg
						try {
							errMsg = JSON.parse(err.message.match(/\{.*\}$/)).message
						} catch(e) {
							errMsg = err.message
						}
						new Toast('toaster', I18N.translateAndFormat('PayPal has found errors in the order: "{0}"', errMsg), Toast.ERROR)
						console.debug('Refreshing paypal buttons...')
						this._isPayPalInitialized = false
						document.getElementById('paypal-button-container').innerHTML = ''
						this._enablePayPalButtons()
					}
				})
					.render('#paypal-button-container')
				this._isPayPalInitialized = true
				// schedule buttons refresh
				/*if (!this._payPalButtonsUpdateInterval) {
					this._payPalButtonsUpdateInterval = setInterval(() => {
						console.debug('Refreshing paypal buttons...')
						this._isPayPalInitialized = false
						document.getElementById('paypal-button-container').innerHTML = ''
						this._enablePayPalButtons()
					}
						, 1 * 60 * 1000)
				}*/
				spinner.dismiss()
			})
			.catch(err => {
				console.error('failed to load the PayPal JS SDK script', err)
			})
	}

	/**
	 * 
	 * @returns true if accepted
	 */
	_checkTermsOfServiceAccepted = () => {
		if (!this._target.querySelector('#termsOfServiceAcceptedCb').checked) {
			this._termsOfServiceNotAcceptedToast = new Toast('toaster', I18N.translate('Please accept the terms of service'), Toast.WARN)
			this._target.querySelector('#termsOfServiceAcceptedCb').setAttribute('invalid', '')
			sessionStorage.removeItem('termsOfServiceAccepted')
			return false
		}
		else {
			if (this._termsOfServiceNotAcceptedToast) {
				this._termsOfServiceNotAcceptedToast.dismiss()
			}
			this._target.querySelector('#termsOfServiceAcceptedCb').removeAttribute('invalid')
			sessionStorage.setItem('termsOfServiceAccepted', 'true')
			return true
		}
	}

	/**
	 * 
	 * @returns true if all are present
	 */
	_checkRequiredInputs = () => {
		let requiredInputMissing = false
		this._target.querySelectorAll('#customerContact input[required]').forEach(requiredInput => {
			if (!requiredInput.value) {
				requiredInput.setAttribute('invalid', '')
				requiredInputMissing = true;
				new Toast('toaster', I18N.translateAndFormat('{0} missing!', requiredInput.labels[0].innerText), Toast.WARN, 15)
			}
		})
		return !requiredInputMissing
	}

	_createCamundaRequestBody = () => {
		return {
			variables: {}
		}
	}

	_setCamundaBooleanRequestVariable = (requestBody, varName, bool) => {
		requestBody.variables[varName] = {
			"value": Boolean(bool),
			"type": "Boolean"
		}
	}

	_setCamundaIntegerRequestVariable = (requestBody, varName, int) => {
		requestBody.variables[varName] = {
			"value": Number(int),
			"type": "Integer"
		}
	}

	_setCamundaDoubleRequestVariable = (requestBody, varName, double) => {
		requestBody.variables[varName] = {
			"value": Number(double),
			"type": "Double"
		}
	}

	_setCamundaStringRequestVariable = (requestBody, varName, string) => {
		requestBody.variables[varName] = {
			"value": string,
			"type": "String"
		}
	}

	_setCamundaJsonRequestVariable = (requestBody, varName, json) => {
		requestBody.variables[varName] = {
			"value": JSON.stringify(json),
			"type": "Json"
			/*"type": "Object",
			"valueInfo": {
				"objectTypeName": "de.fairweben.camunda.fulfillment.data.Payment",
				"serializationDataFormat": "application/json"
			}*/
		}
	}

	_acceptToReceiveNewsletter = acceptNewsletter => {
		this._orderVO.contact.acceptNewsletter = acceptNewsletter
		fetch(`/crm/newsletter`, {
			method: 'POST',
			mode: 'cors', // no-cors, *cors, same-origin
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'same-origin', // include, *same-origin, omit
			referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
			headers: {
				'Content-Type': 'application/json; charset=UTF-8'
			},
			body: JSON.stringify(this._orderVO.contact)
		})
			.then(response => {
				if (response.ok) {
					if (acceptNewsletter) {
						if (localStorage.getItem('newsletterOrdered') !== 'true') {
							new Toast('toaster', I18N.translate('Newsletter ordered.'), Toast.INFO, 10)
						}
						localStorage.setItem('newsletterOrdered', 'true')
					}
					else {
						if (localStorage.getItem('newsletterOrdered') === 'true') {
							new Toast('toaster', I18N.translate('No newsletter wanted.'), Toast.INFO, 10)
						}
						localStorage.setItem('newsletterOrdered', 'false')
					}
				}
				else {
					new Toast('toaster', I18N.translate('Failed to order Newsletter!'), Toast.WARN, 15)
				}
			})
			.catch(e => {
				new Toast('toaster', I18N.translate('Failed to order Newsletter! ' + e), Toast.WARN, 15)
			})
	}

	setAppContext = appContext => this._appContext = appContext

	setVisible = visible => {
		if (this._visible === visible) {
			return
		}
		this._visible = visible
		visible ? this._target.removeAttribute('hidden') : this._target.setAttribute('hidden', '')
		if (document.getElementById('paymentMethodPayPalRb').checked) {
			this._enablePayPalButtons()
			document.getElementById('buyBtn').setAttribute('hidden', '')
			document.getElementById('buyBtn').setAttribute('disabled', '')
			document.getElementById('paypal-button-container').removeAttribute('hidden')
		}
		else {
			document.getElementById('paypal-button-container').setAttribute('hidden', '')
			document.getElementById('buyBtn').removeAttribute('hidden')
			document.getElementById('buyBtn').removeAttribute('disabled')
		}
	}

}
